<script>
import {onMounted, watch} from "vue";
import useSharedData from "@/use/SharedData";
import {usePaySlipAnnexStore} from "@/stores/PaySlipAnnex";
import {storeToRefs} from "pinia";
import {useSecurityStore} from "@/stores/Security";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    name: "AnnexSelect",
    props: {
        value: Number,
        autoSelect: Boolean,
        label: String,
        rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const {transformFilterValues} = useSharedMethod();
        const annexStore = usePaySlipAnnexStore();
        const securityStore = useSecurityStore();

        const {annexId} = storeToRefs(annexStore);

        function findAll() {
            loading.value = true;
            let descending;
            if (securityStore.userContext.paySlipAnnexSelect === 'LAST_ONE') {
                descending = true;
            } else if (securityStore.userContext.paySlipAnnexSelect === 'FIRST_ONE') {
                descending = false;
            }
            axios.get('/paySlipAnnexes', {
                params: transformFilterValues({
                    sortBy: 'month',
                    allRecords: true,
                    descending: descending,
                })
            }).then(response => {
                annexStore.setPaySlipAnnexes(response.data.elements);
                if (props.autoSelect)
                    select();
            }).finally(() => {
                loading.value = false;
            });
        }


        function select() {
            annexId.value = annexStore.getMax();
            emit('input', annexId.value);
        }

        watch(() => annexId.value, () => {
            emit('input', annexId.value);
        });

        watch(() => props.value, () => {
            if (!props.autoSelect)
                annexId.value = props.value;
        }, {immediate: true});


        onMounted(() => findAll());

        return {
            annexStore,
            annexId,
            loading,
            inputColor,
            backgroundColor,
        }
    }
}
</script>

<template>
    <div>
        <v-select
            v-model="annexId"
            :items="annexStore.paySlipAnnexes"
            item-value="id"
            item-text="name"
            outlined
            dense
            clearable
            :label="label"
            :loading="loading"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            @input="$emit('input', annexId)"
            :rules="rules"
        ></v-select>

        <input type="hidden"/>
    </div>
</template>